import React from 'react';
import { PipeObject, Replacement, Token } from '../types';
import { uuid } from '../../utils/uuid/uuid';
import { RenderCustomComponent } from '../../utils/render-custom-component/render-custom-component';
// only works with <xxxx ddd=fff />>
export type CustomComponentType = {
  name: string;
  component: Function | unknown;
};

export type CustomComponentProps = {
  customComponentWrapper?: any;
  customComponents?: CustomComponentType[];
  cb?: unknown;
  env?: string;
};
export const CustomComponent = ({
  customComponentWrapper,
  customComponents,
  cb,
  env,
}: CustomComponentProps = {}) => {
  return ({ input, data, lex }: PipeObject) => {
    //  check to see if we have any custom components passed in
    if (customComponents && customComponents.length > 0) {
      let obj: Token;
      let replacements: Replacement[] = [];
      while ((obj = lex.next())) {
        let customComponentStart, customComponentEnd, customComponent;
        // check if we are at element_start
        if (obj.token === 'element_start') {
          // move to the next one, and see if it matches a custom component
          obj = lex.next();
          if (obj.token === 'string' && obj.value) {
            // check to see if value exists in custom components array
            customComponent = customComponents.find(
              (x) => x.name === obj.value
            );
            if (customComponent) {
              customComponentStart = obj;
              // we have a match keep looping until we get to element_end
              while ((obj = lex.next())) {
                if (obj.token === 'element_end') {
                  customComponentEnd = obj;
                  break;
                }
              }
            }
          }
        }

        if (customComponentStart && customComponentEnd && customComponent) {
          const id = customComponent?.name || uuid();
          // check input string if it starts with < OR &lt;
          const isLessThanHtmlCode =
            input.substring(
              customComponentStart.begin - 1,
              customComponentStart.begin
            ) !== '<';
          const fullComponent = input.substring(
            customComponentStart.begin - (isLessThanHtmlCode ? 4 : 1),
            customComponentEnd.end + 1
          );
          const props = input
            .substring(
              customComponentStart.end + 1,
              customComponentEnd.begin - 1
            )
            .trim()
            .split(' ')
            .reduce((prev, curr) => {
              const [key, value] = curr.split('=');
              return { ...prev, [key]: eval(value) };
            }, {});
          const CustomComponent = customComponent.component;
          if (CustomComponent) {
            const Component =
              typeof CustomComponent === 'function' ? (
                <CustomComponent data={data} cb={cb} env={env} {...props} />
              ) : (
                React.cloneElement(CustomComponent, { data, ...props })
              );

            replacements.push({
              searchValue: fullComponent,
              replaceValue: Component as any,
              id,
            });
          } else {
            replacements.push({
              searchValue: fullComponent,
              replaceValue: '',
              id,
            });
          }
        }
      }

      for (const rep of replacements) {
        if (rep.replaceValue) {
          input = input.replace(
            rep.searchValue,
            `<span id="${rep.id}"></span>`
          );

          RenderCustomComponent(
            customComponentWrapper,
            rep.replaceValue,
            rep.id
          );
        } else {
          input = input.replace(rep.searchValue, rep.replaceValue);
        }
      }
    }

    return { input, data, lex };
  };
};
